module.exports = __webpack_public_path__ + "img/coins.c5fb5e4f.png";